import React, { useEffect } from 'react'

const SPREADSHIRT_URL = 'https://shop.spreadshirt.co.uk/wingbeat'

function ShopPage() {
  useEffect(() => {
    // Open the external shop in a NEW tab (leaving this page in place), rather
    // than replacing the current tab. The nav/footer Shop links already open a
    // new tab directly; this covers a direct visit/bookmark to /shop.
    const timer = setTimeout(() => {
      window.open(SPREADSHIRT_URL, '_blank', 'noopener,noreferrer')
    }, 1500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Club Shop</h1>
        <p>Official Wingbeat merchandise</p>
      </div>
      
      <div className="page-content" style={{ textAlign: 'center', padding: '60px 20px' }}>
        <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
          Opening the Wingbeat shop in a new tab…
        </p>
        <p style={{ marginBottom: '30px' }}>
          <a 
            href={SPREADSHIRT_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '14px 30px',
              background: '#4a8f4a',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '8px',
              fontSize: '1.1em',
              fontWeight: '500'
            }}
          >
            Visit Wingbeat Shop on Spreadshirt →
          </a>
        </p>
        <p style={{ color: '#888', fontSize: '0.9em' }}>
          Our merchandise is hosted on Spreadshirt. It should open in a new tab —
          if it doesn't, use the button above.
        </p>
      </div>
    </div>
  )
}

export default ShopPage
